const AD_TYPE_FULL = "full";
const AD_TYPE_FOUR_CORNERS_CATEGORY = "fourCornersCategory";
const AD_TYPE_HALF = "half";
const AD_TYPE_ONE_FOURTH = "oneFourth";
const AD_TYPE_ONE_FOURTH_MIX = "oneFourthMix";
const AD_TYPE_ONE_SIXTH = "oneSixth";
const AD_TYPE_ONE_THIRD = "oneThird";
const VIEW_NAME_SKELETON = "skeleton";
const PRODUCT_TILE_CAROUSEL_CONTAINER = "AdButlerProductTileCarouselContainer";
export {
  AD_TYPE_FOUR_CORNERS_CATEGORY,
  AD_TYPE_FULL,
  AD_TYPE_HALF,
  AD_TYPE_ONE_FOURTH,
  AD_TYPE_ONE_FOURTH_MIX,
  AD_TYPE_ONE_SIXTH,
  AD_TYPE_ONE_THIRD,
  PRODUCT_TILE_CAROUSEL_CONTAINER,
  VIEW_NAME_SKELETON
};
